import { useEffect } from "react";
const useOnClickOutside = function (ref, handler) {
  let executeHandler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  useEffect(() => {
    const listener = event => {
      const target = event.target;
      const refs = Array.isArray(ref) ? ref : [ref];

      // Check if the click is inside any of the referenced elements
      if (refs.some(r => r.current && r.current.contains(target))) {
        return;
      }

      // Check if the target is an interactive element (button, input, etc.)
      const interactiveElement = target.closest('button, input, select, textarea, a[href], [role="button"], [tabindex]');
      if (interactiveElement && refs.some(r => r.current && r.current.contains(interactiveElement))) {
        return;
      }
      if (executeHandler) {
        handler(event);
      }
    };

    // Only add listeners if executeHandler is true
    if (executeHandler) {
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
    }
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler, executeHandler]);
};
export default useOnClickOutside;